module.exports = __webpack_public_path__ + "img/circuit-court.41e3a0f5.png";